import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { Checkbox } from "../../../UI.BaseControls/Checkbox";
import { ElementUtils } from "../../../UI.ElementarControls/Helpers/ElementUtils";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { MessageWindow } from "../MessageWindow";
import { IContentBuilder } from "./IContentBuilder";

export type DownloadSelectBuilderOption = {
    attrName: string;
    titleLocKey: string;
    titleLocParams?: string[];
};

/**
 * @internal
 */
export class DownloadSelectBuilder implements IContentBuilder {
    private static readonly _blockClass = "download-select-dialog";

    private readonly _options: DownloadSelectBuilderOption[];
    private readonly _parent: MessageWindow;
    private readonly _selectAllLocKey: string;
    private readonly _deselectAllLocKey: string;

    private _selectedAttributes: string[];

    /**
     * Kolekce u�ivatelem vybran�ch aplika�n�ch atribut�
     */
    public get selectedAttributes(): string[] {
        return this._selectedAttributes;
    }

    /**
     * Vytvoří obsah dialogu pro výběr souborů ke stažení
     * @param parent Rodičovské okno
     * @param options Možnosti výběru
     * @param selectAllLocKey Lokalizační klíč pro možnost "vybrat vše"
     * @param deselectAllLocKey Lokalizační klíč pro možnost "zrušit výběr"
     */
    constructor(parent: MessageWindow, options: DownloadSelectBuilderOption[], selectAllLocKey: string, deselectAllLocKey: string) {
        this._options = options;
        this._parent = parent;
        this._selectAllLocKey = selectAllLocKey;
        this._deselectAllLocKey = deselectAllLocKey;

        this._parent.leftButton1Caption = this._selectAllLocKey;
    }

    public async build(): Promise<HTMLElement> {
        const container = createElement({ classes: DownloadSelectBuilder._blockClass });
        const checkBoxes: Checkbox[] = [];
        for (const o of this._options) {
            const option = createElement({ classes: `${DownloadSelectBuilder._blockClass}__option` }); //'

            const checkBox = new Checkbox();
            checkBox.classList.add(`${DownloadSelectBuilder._blockClass}__checkbox`);
            checkBox.dataset["attrname"] = o.attrName;
            checkBox.standardAction = true;
            checkBox.isNullable = false;
            checkBox.addEventListener("change", () => this._checkboxValueChanged(checkBoxes));
            checkBoxes.push(checkBox);

            const title = createElement({ classes: `${DownloadSelectBuilder._blockClass}__title` }); //'
            Localization.addLocData(title, o.titleLocKey, Localization.TEXT_CONTENT, undefined, o.titleLocParams);

            option.appendChild(checkBox);
            option.appendChild(title);
            container.appendChild(option);
        }

        ElementUtils.toggleAttribute(this._parent.okButton, "disabled", true);
        this._parent.left1Callback = async () => {
            this._toggleSelectAll(checkBoxes);
            return false; // nezavírat dialog
        };

        return container;
    }

    private _checkboxValueChanged(checkBoxes: Checkbox[]): void {
        this._selectedAttributes = checkBoxes.filter(cb => cb.checked).map(cb => cb.getAttribute("data-attrname"));
        ElementUtils.toggleAttribute(this._parent.okButton, "disabled", this._selectedAttributes.length === 0);
        Localization.addLocData(this._parent.leftButton1, checkBoxes.every(cb => cb.checked) ? this._deselectAllLocKey : this._selectAllLocKey);
    }

    private _toggleSelectAll(checkBoxes: Checkbox[]): void {
        const allChecked = checkBoxes.every(cb => cb.checked);
        checkBoxes.forEach(cb => cb.checked = !allChecked);
        this._checkboxValueChanged(checkBoxes);
    }
}
